import React, { useEffect, useState } from 'react';
import Base from '../Base';
import Card from '../../components/elements/Card';
import Title from '../../components/common/Title';
import Back from '../../components/common/Back';
import Icon from '../../components/common/Icon';
import NotFound from '../../components/common/NotFound';
import { useTranslation } from 'react-i18next';
import { fetchUserInfo } from '../../utils';

// The image is shown in the app, never linked: the blob is served as a download,
// so a link to it leaves the app and drops a file instead of showing the map.
const VenueMap = () => {
  const { t } = useTranslation();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchUserInfo('/event', setEvent, setLoading, setError);
  }, []);

  const src = event?.venue_map;

  return (
    <Base activeNav="home">
      <Card>
        <Back to="/home" />
        <Title my="1" className="mt-3">
          <Icon name="map" theme="primary" className="me-2" />
          {t('venueMap')}
        </Title>
      </Card>

      {src ? (
        <Card>
          <img src={src} alt={t('venueMap')} className="d-block w-100 h-auto rounded" />
        </Card>
      ) : (
        <NotFound loading={loading} />
      )}

      {!!error && !loading && (
        <Card>
          <p className="text-danger mb-0">{t(error)}</p>
        </Card>
      )}
    </Base>
  );
};

export default VenueMap;
